<template>
  <v-container>
    <v-row dense>
      <v-col v-for="(item, i) in items" :key="i" lg="4" sm="6" md="6" cols="12">
        <v-card height="100%" outlined @click="handleClick(item)">
          <div>
            <div class="text-center mt-3">
              <v-icon :color="item.color">
                {{ item.icon }}
              </v-icon>
            </div>
            <v-card-title class="justify-center">
              <span class="font-weight-bold">{{ item.title }}</span>
            </v-card-title>
            <v-card-subtitle class="text-center"
              ><v-chip x-small disabled outlined>{{
                item.vector
              }}</v-chip></v-card-subtitle
            >
            <v-card-text class="text-center">
              <div>{{ item.description }}</div>
            </v-card-text>
            <v-card-actions> </v-card-actions>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <component v-bind:is="dialog" @update="updateComponent"></component>

    <!-- demo toast -->
    <v-snackbar color="error" v-model="snackbar_visible" :timeout="snackbar_timeout">
      {{ snackbar_text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          plain
          snackbar_text
          v-bind="attrs"
          @click="snackbar_visible = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
// import router from "../router.js";
import ApkScan from "./forms/ApkScan.vue"
import AwsScan from "./forms/AwsScan.vue"
import GcpScan from "./forms/GcpScan.vue"
import NetworkSingleScan from "./forms/NetworkSingleScan.vue"
import NetworkMultipleScan from "./forms/NetworkMultipleScan.vue"
import NetworkBaselineScan from "./forms/NetworkBaselineScan.vue"
import NetworkMitmScan from "./forms/NetworkMitmScan.vue"
import AndroidScan from "./forms/AndroidScan.vue"
import BinaryGenericScan from "./forms/BinaryGenericScan.vue"
export default {
  components: {
    ApkScan,
    AwsScan,
    GcpScan,
    NetworkSingleScan,
    NetworkMultipleScan,
    NetworkMitmScan,
    NetworkBaselineScan,
    BinaryGenericScan,
    AndroidScan
  },
  data: () => ({
    dialog: null,
    snackbar_visible: false,
    snackbar_text: "Demo instance - functionality disabled",
    snackbar_timeout: 2000,
    items: [
      {
        icon: "mdi-lan-connect",
        color: "orange",
        title: "Network (Single Endpoint)",
        description:
          "Perform analysis for a single endpoint from a packet capture",
        vector: "Network (Privileged)",
        action: "NetworkSingleScan"
      },
      {
        icon: "mdi-lan",
        color: "orange",
        title: "Network (Multiple Endpoints)",
        description:
          "Perform analysis for multiple endpoints from one or more packet captures",
        vector: "Network (Privileged)",
        action: "NetworkMultipleScan"
      },
      {
        icon: "mdi-google-play",
        color: "blue",
        title: "APK",
        description: "Decompile and analyse an Android APK",
        vector: "Physical (Mixed)",
        action: "ApkScan"
      },
      {
        icon: "mdi-ab-testing",
        color: "orange",
        title: "Network (vs Baseline)",
        description:
          "Compare packet capture to expected baseline for anomalies",
        vector: "Network (Privileged)",
        action: "NetworkBaselineScan"
      },
      {
        icon: "mdi-incognito",
        color: "red",
        title: "Network (MITM)",
        description:
          "Perform Man-in-the-Middle analysis from a packet capture",
        vector: "Network (Privileged)",
        action: "NetworkMitmScan"
      },
      {
        icon: "mdi-application-brackets-outline",
        color: "blue",
        title: "Binary (Generic)",
        description: "Decompile and analyse a binary",
        vector: "Physical (Mixed)",
        action: "BinaryGenericScan"
      },
      {
        icon: "mdi-android",
        color: "green",
        title: "Android Device",
        description: "Perform Android device analysis",
        vector: "Physical (Privileged)",
        action: "AndroidScan"
      },
      {
        icon: "mdi-cloud",
        color: "green",
        title: "AWS",
        description: "Perform analysis of AWS cloud infrastructure",
        vector: "Involved (AWS)",
        action: "AwsScan"
      },
      {
        icon: "mdi-cloud",
        color: "green",
        title: "Google Cloud",
        description: "Perform analysis of Google Cloud Platform infrastructure",
        vector: "Involved (Google)",
        action: "GcpScan"
      },
    ],
  }),
  methods: {
    handleClick(item) {
      // TODO: Remove when all detectors are available
      if (item.action) {
        this.updateComponent(item.action)
      }
      else {this.snackbar_visible = true}
    },
    updateComponent(item) {
      this.dialog = item
    }
  },
};
</script>
